// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+tFIC","loader-container":"Loader_loader-container__5udDR","load-main-cont":"Loader_load-main-cont__OBbLl","spin89345":"Loader_spin89345__P4qrP"};